{
	"title": "Dashboard",
	"subtitle": "{{games}}. Where every medal event stands, what the desk owes, and who is winning.",
	"noGames": {
		"title": "No games yet",
		"body": "The medal desk opens once a games is set up in GMS."
	},
	"hero": {
		"label": "Games status",
		"eyebrow": "Medal desk",
		"noGames": "No games chosen",
		"dayOf": "Day {{n}} of {{of}}",
		"startsOn": "Starts {{day}}",
		"dates": "{{from}} to {{to}}",
		"gamesTime": "Games time: {{time}}",
		"yourTime": "{{day}} · your time ({{zone}})",
		"live": "Live",
		"liveUpdated": "Live · updated {{time}}",
		"reconnecting": "Reconnecting…"
	},
	"kpi": {
		"label": "Key figures",
		"ofTotal": "{{n}} of {{total}}",
		"decided": "Medal events decided",
		"decidedDetail": "{{awarded}} awarded · {{none}} with no medals",
		"waiting": "Waiting for the desk",
		"waitingDetail": "Every medal meet official, not awarded yet",
		"waitingLive_one": "{{n}} more event live now",
		"waitingLive_other": "{{n}} more events live now",
		"openQueue": "Award",
		"medals": "Medals awarded",
		"medalsDetail_one": "{{n}} medal still to award",
		"medalsDetail_other": "{{n}} medals still to award",
		"dayGolds": "Golds on {{day}}",
		"dayGoldsNone": "Golds today",
		"ofDue": "{{n}} of {{due}}",
		"dayDetail": "{{settled}} of {{due}} events settled that day",
		"noCalendar": "No games days yet"
	},
	"pipeline": {
		"title": "Medal pipeline",
		"description": "All {{n}} medal events, from not scheduled to awarded. Select a stage to list its events.",
		"state": "Stage",
		"events": "Medal events",
		"competingDetail": "{{live}} live · {{unofficial}} unofficial",
		"open": "{{state}}: {{n}} events. Show them in the medal events table"
	},
	"firsts": {
		"title": "Firsts",
		"subtitle": "The first gold, silver and bronze awarded: of the games, and of the selected day.",
		"games": "Of the games",
		"day": "On {{day}}",
		"dayNone": "Of the day",
		"notYet": "No {{medal}} awarded yet"
	},
	"timeline": {
		"title": "Run sheet · {{day}}",
		"count_one": "{{n}} medal event decided this day",
		"count_other": "{{n}} medal events decided this day",
		"previous": "Previous day",
		"next": "Next day",
		"today": "Today",
		"empty": "No medal event is decided on this day.",
		"more": "{{n}} more events this day: see the medal events table.",
		"now": "Now, {{time}}",
		"nowShort": "Now",
		"locked": "Locked",
		"live_one": "{{count}} meet live",
		"live_other": "{{count}} meets live",
		"awardBy": "Award by {{time}}",
		"ceremony": "Ceremony {{time}}"
	},
	"byDay": {
		"title": "Medals by day",
		"description": "Medals awarded each games day, against what the day's events expect. Select a day.",
		"day": "Day"
	},
	"topTally": {
		"title": "Medal tally · top 10",
		"description": "Ranked by gold, then silver, then bronze. Sort by a colour to reorder.",
		"sortLabel": "Order",
		"sort": {
			"rank": "Standing",
			"gold": "Most gold",
			"silver": "Most silver",
			"bronze": "Most bronze",
			"total": "Most medals"
		},
		"empty": "No medal has been awarded here yet."
	},
	"leader": {
		"title": "Day leader · {{day}}",
		"subtitle": "Medals awarded on this day only.",
		"empty": "No medal was awarded on this day.",
		"leader": "Leader of the day",
		"tied_one": "Tied for the lead",
		"tied_other": "{{count}} NOCs tied for the lead",
		"mostOf": "Most {{medal}}",
		"busiest": "Busiest sport",
		"busiestValue": "{{sport}} · {{n}}",
		"bySport": "Leader by sport",
		"medals_one": "{{n}} medal",
		"medals_other": "{{n}} medals",
		"ranked": "The day's standing"
	},
	"releases": {
		"title": "Latest releases",
		"subtitle": "Awarded events, newest first.",
		"count_one": "{{n}} event awarded",
		"count_other": "{{n}} events awarded",
		"openAll": "All awarded",
		"search": "Search events",
		"empty": "No event has been awarded yet.",
		"emptyFiltered": "No awarded event matches these filters.",
		"by": "Released by {{name}}",
		"latency_one": "{{n}} minute after official",
		"latency_other": "{{n}} minutes after official",
		"latencyHours": "{{h}} h {{m}} min after official"
	},
	"queues": {
		"label": "The desk's lists"
	},
	"events": {
		"title": "Medal events",
		"count_one": "{{n}} event",
		"count_other": "{{n}} events",
		"statesLabel": "Filter by stage",
		"allStates": "All stages",
		"search": "Search events",
		"day": "Decided on",
		"sort": "Order",
		"sortSchedule": "By schedule",
		"sortRecent": "Latest activity",
		"col": {
			"event": "Event",
			"state": "Stage",
			"due": "Decided at",
			"desk": "Desk",
			"ceremony": "Ceremony",
			"medallists": "Medals"
		},
		"unscheduled": "Not scheduled",
		"awardedAt": "Awarded {{time}}",
		"awardBy": "Award by {{time}}",
		"officialOf": "{{official}} of {{total}} official",
		"expected": "G {{g}} · S {{s}} · B {{b}}",
		"expectedTitle": "Medals the event expects",
		"emptyTitle": "No medal event matches",
		"emptyBody": "Clear a filter to see more.",
		"summary": "{{from}}–{{to}} of {{total}} events"
	}
}
